import React, { useState } from "react";
import { Grid, Box, Typography, useMediaQuery } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";


const borderStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    minHeight: "620px",
    //borderRadius: "30px",
    padding: "24px",
    background:
        "radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165, 239, 255, 0.2) 0%, rgba(110, 191, 244, 0.0447917) 77.08%, rgba(70, 144, 213, 0) 100%)",
    "&::before": {
        content: '""',
        position: "absolute",
        top: "-1px",
        left: "-1px",
        right: "-1px",
        bottom: "-1px",
        borderRadius: "30px",
        padding: "0.85px",
        background:
            "radial-gradient(80.38% 222.5% at -13.75% -12.36%, #98F9FF 0%, rgba(255, 255, 255, 0) 100%), radial-gradient(80.69% 208.78% at 108.28% 112.58%, #EABFFF 0%, rgba(135, 38, 183, 0) 100%)",
        WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMaskComposite: "destination-out",
        maskComposite: "exclude",
        zIndex: -1,
    },

    "@media (max-width: 960px)": { // Equivalent to "md" breakpoint
        minHeight: "400px", // Reduce height on smaller screens
    },

}


const MainContainer = styled(Box)(() => ({
    background: "#000",
    display: "flex",
    flexDirection: "column",
    padding: "60px 24px",
    position: "relative",
    overflow: "hidden",
    width: "100%",
    margin: "0 auto",
}));

const ContentContainer = styled(Box)(() => ({
    width: "97%",
    maxWidth: "1200px",
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
}));






const GraphViewSection = ({ title, subTitle, data }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <MainContainer>
            <ContentContainer>
                <Box sx={{ width: { xs: "100%", md: "70%" } }}>
                    <Typography
                        variant="h2"
                        sx={{
                            background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            fontSize: { xs: "24px", sm: "32px", md: "40px" },
                            fontWeight: 700,
                            mb: { xs: 2, md: 5 },
                        }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        sx={{
                            color: "#8C8CC2",
                            fontSize: { xs: "14px", md: "18px" },
                            lineHeight: 1.8,
                            textAlign: "left",
                            marginTop: 2,
                            marginBottom: 10,
                        }}
                    >
                        {subTitle}
                    </Typography>
                </Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={3.5}>
                        <Box sx={{
                            p: "24px",
                            borderRadius: "30px",
                            maxWidth: "300px",
                            minHeight: isMobile ? "auto" : "640px",
                            background: "radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165, 239, 255, 0.2) 0%, rgba(110, 191, 244, 0.0447917) 77.08%, rgba(70, 144, 213, 0) 100%)"
                        }}>
                            {data[0]?.menuItems?.map((item, index) => (
                                <Box
                                    key={index}
                                    onClick={() => setActiveIndex(index)}
                                    sx={{
                                        padding: "16px 15px",
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        color: activeIndex === index ? "#61D1FA" : "#fff",
                                        borderRadius: "8px",
                                        marginBottom: "8px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "14px",
                                    }}
                                >
                                    <item.Icons /> {/* Corrected from item.Icon to item.Icons */}
                                    {item.title}
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={8.5}>
                        <Box >
                            {data[0].viewData[activeIndex].imgUrl.length === 1 ? (
                                <img
                                    src={data[0].viewData[activeIndex].imgUrl[0]}
                                    alt="Graph"
                                    style={{
                                        borderRadius: "12px",
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        display: "block",
                                    }}
                                />
                            ) : (
                                <Grid container spacing={1}>
                                        <>
                                        <Grid item xs={12} md={12}>
                                            
                                                <img
                                                    src={data[0].viewData[activeIndex].imgUrl[0]}
                                                    alt={`Graph1`}
                                                    style={{
                                                        borderRadius: "12px",
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        display: "block",
                                                    }}
                                                />
                                            
                                        </Grid>
                                        {/* <Grid item xs={12} sm={6} md={6} >
                                            
                                                <img
                                                   src={data[0].viewData[activeIndex].imgUrl[1]}
                                                    alt={`Graph`}
                                                    style={{
                                                        borderRadius: "12px",
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        display: "block",
                                                    }}
                                                />
                                            
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} >                                           
                                                <img
                                                     src={data[0].viewData[activeIndex].imgUrl[2]}
                                                    alt={`Graph`}
                                                    style={{
                                                        borderRadius: "12px",
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        display: "block",
                                                    }}
                                                />
                                            
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} >            
                                                <img
                                                    src={data[0].viewData[activeIndex].imgUrl[3]}
                                                    alt={`Graph`}
                                                    style={{
                                                        borderRadius: "12px",
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        display: "block",
                                                    }}
                                                />   
                                        </Grid> */}
                                        </>
                                    
                                </Grid>
                            )}
                        </Box>
                    </Grid>

                </Grid>
            </ContentContainer>
        </MainContainer >
    );
};

export default GraphViewSection;
